<script setup>
import { ref } from 'vue';
import FormSelect from 'v3/components/Form/Select.vue';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { setColorPalette } from 'dashboard/helper/themeHelper';

defineProps({
  label: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    required: true,
  },
});

// Client-only preference, same storage mechanism as the light/dark toggle
// (themeHelper.js) — no account-wide UI setting to sync, every agent picks
// their own.
const selectedValue = ref(
  LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_PALETTE) || 'default'
);

const handleChange = value => {
  LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_PALETTE, value);
  setColorPalette();
};
</script>

<template>
  <div class="flex gap-2 justify-between w-full items-start">
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">
        {{ label }}
      </label>
      <p class="text-n-gray-11">
        {{ description }}
      </p>
    </div>
    <FormSelect
      v-model="selectedValue"
      name="colorPalette"
      spacing="compact"
      class="min-w-28 mt-px"
      :options="options"
      label=""
      @update:model-value="handleChange"
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </FormSelect>
  </div>
</template>
